module.exports = __webpack_public_path__ + "img/no_orders.336bac62.svg";